import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PayButtons, isTrialEligible } from "@/components/sg/PayButtons";
import { PRICING_FALLBACK } from "@/components/sg/PlanCards";

export const openCheckout = (lookupKey) => window.dispatchEvent(new CustomEvent("sg:checkout", { detail: lookupKey }));

const LABEL = { premium: "Premium", super_premium: "Super Premium" };

export function CheckoutDialog() {
  const { user } = useAuth();
  const [key, setKey] = useState(null);
  useEffect(() => {
    const on = (e) => setKey(e.detail);
    window.addEventListener("sg:checkout", on);
    return () => window.removeEventListener("sg:checkout", on);
  }, []);
  if (!user) return null;
  const planId = key ? key.replace(/_(monthly|yearly)$/, "") : "";
  const yearly = key?.endsWith("yearly");
  const amount = key ? PRICING_FALLBACK[key]?.amount : 0;
  const trial = planId === "super_premium" && isTrialEligible(user);
  return (
    <Dialog open={!!key} onOpenChange={(o) => !o && setKey(null)}>
      <DialogContent className="max-w-sm w-[calc(100vw-2rem)]" data-testid="checkout-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{trial ? "Start your 7-day free trial" : `Get ${LABEL[planId] || ""}`}</DialogTitle>
          <DialogDescription data-testid="checkout-dialog-summary">
            {LABEL[planId]} · ${amount?.toFixed(2)} / {yearly ? "year" : "month"}
            {trial ? " after 7 free days" : ""}. Choose how you'd like to pay.
          </DialogDescription>
        </DialogHeader>
        {key && <PayButtons lookupKey={key} trial={trial} testPrefix="checkout" />}
      </DialogContent>
    </Dialog>
  );
}
